module.exports = "/_next/static/images/Understand@2x-b637739380f7f4433f1336e9a3814aec.png";